import { serviceDirectoryApiClient } from '@/services/service-directory';

export interface ServiceForm {
  serviceCategory: string;
  serviceName: string;
  serviceDescription: string;
  serviceCurrency: string;
  serviceCost: number;
}

class ServiceCatalogue {
  fetchServices = async (organisationId: string, pageNumber?: number, pageSize?: number, searchText?: string) => {
    const response = await serviceDirectoryApiClient.get('services', {
      headers: {
        organisationId,
      },
      params: {
        pageNumber,
        pageSize,
        searchText,
      },
    });
    return response.data;
  };

  fetchService = async (organisationId: string, id: string) => {
    const response = await serviceDirectoryApiClient.get(`services/${id}`, {
      headers: {
        organisationId,
      },
    });
    return response.data;
  };

  createService = async (organisationId: string, service: ServiceForm) => {
    const formData = this.formDataService(service);
    const response = await serviceDirectoryApiClient.post('services', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        organisationId,
      },
    });

    return response.data;
  };

  updateService = async (organisationId: string, id: string, service: ServiceForm) => {
    const response = await serviceDirectoryApiClient.put(`services/${id}`, service, {
      headers: {
        'Content-Type': 'application/json',
        organisationId,
      },
    });
    return response.data;
  };

  deleteService = async (organisationId: string, id: string) => {
    const response = await serviceDirectoryApiClient.delete(`services/${id}`, {
      headers: {
        organisationId,
      },
    });
    return response.data;
  };

  private formDataService = (service: ServiceForm) => {
    const formData = new FormData();
    formData.append('serviceCategory', service.serviceCategory ?? '');
    formData.append('serviceName', service.serviceName ?? '');
    formData.append('serviceDescription', service.serviceDescription ?? '');
    formData.append('serviceCurrency', service.serviceCurrency ?? '');
    formData.append('serviceCost', service.serviceCost.toString() ?? '');
    return formData;
  };
}

export const ServiceCatalogueInstance = new ServiceCatalogue();
